import React, { useState, useEffect, useRef, useContext } from "react";
import { IoMdMenu } from "react-icons/io";

import "./home.css";
import StudentProfile from "../Student/student";
import WelcomePage from "../Welcome/welcome";
import AccessHold from "../AccessHold/AccessHold";
import AccessExpired from "../AccessExpired/AccessExpired";
import AccessPending from "../AccessPending/AccessPending";

const Home = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("student")));
  const [activeTab, setActiveTab] = useState();

  const [activeGC, setActiveGC] = useState(() => {
    const value = JSON.parse(sessionStorage.getItem("activeGC"));
    if (value) {
      return value;
    }
    return "";
  });

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [gcData, setGcData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const sidebarRef = useRef(null);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    if (!activeGC) return; // prevent unnecessary fetch on initial render

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/cheat-sheet`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              course: user?.student?.program,
              gc: activeGC,
              uid: user?.student?.UID,
              joinedDate: user?.student?.joinedDate,
            }),
          }
        );

        const data = await response.json();
        setIsLoading(false);

        data.data.course === "tech-pro"
          ? setActiveTab("Tech Pro")
          : setActiveTab("Tech Smart");

        setGcData(data.data || {});
      } catch (error) {
        console.error("Error fetching GC data:", error);
      }
    };

    fetchData();
  }, [activeGC, user]);

  return (
    <div className="home-bg-container">
      {activeGC === "" && (
        <div className="welcome-page">
          <WelcomePage />
          <StudentProfile />
        </div>
      )}
    </div>
  );
};

export default Home;
